import type { FC } from "react";
import styled from "styled-components";
import { breakpoints } from "../../NavigationBar/theme";

export const StyledAvatar = styled.div<{ $clickable?: boolean }>`
  width: 32px;
  height: 32px;
  border-radius: 116px;
  color: #474747;
  background-color: #e1e1e1;
  display: flex;
  justify-content: center;
  align-items: center;
  font: var(--sinch-comp-tag-font-size-m-label);
  font-weight: 700;
  cursor: ${({ $clickable = true }) => ($clickable ? "pointer" : "initial")};

  @media screen and (max-height: ${breakpoints.heightM}px) {
    & {
      width: 26px;
      height: 26px;
      font-weight: 500;
    }
  }
`;

type ProfileAvatarProps = {
  name: string;
};
export const ProfileAvatar: FC<ProfileAvatarProps> = ({ name }) => {
  const getInitials = (name: string) => {
    const [firstName, lastName] = name.split(" ");
    return `${firstName && firstName[0] ? firstName[0] : ""}${
      lastName && lastName[0] ? lastName[0] : ""
    }`;
  };
  return <StyledAvatar>{getInitials(name)}</StyledAvatar>;
};
